const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const {checkStudentPassword} = require("../../../shared/PasswordCheck");

const StepWrapper = require("./StepWrapper");
const Input = require("../../office/checkout/Input");

const styles = require("./styles/SetPassword.css");

module.exports = createReactClass({
	displayName: "SetPassword",

	propTypes: {
		studentData: PT.object.isRequired,
		copy: PT.object.isRequired,
		renderButton: PT.func.isRequired,
		handleSubmit: PT.func.isRequired,
		onChange: PT.func.isRequired,
		stepNumber: PT.number.isRequired,
		totalNumSteps: PT.number.isRequired,
	},

	getInitialState: function() {
		return {
			password: "",
			repeatPassword: "",
		};
	},

	updateField: function(key, val) {
		this.setState({[key]: val});
		this.props.onChange();
	},

	handlePasswordEnter: function(value) {
		if (value) {
			this.setState({password: value}, () =>
				this.repeatPasswordInput.setFocus()
			);
		}
	},

	handleRepeatPasswordEnter: function(value) {
		if (value) {
			this.setState({repeatPassword: value}, this.handleSubmit);
		}
	},

	handleSubmit: function() {
		const {password, repeatPassword} = this.state;
		const {username, displayName} = this.props.studentData;
		const check = checkStudentPassword(password, repeatPassword, {
			username,
			displayName,
		});
		this.props.handleSubmit(password, check);
	},

	render: function() {
		const wrapperProps = _.pick(this.props, [
			"copy",
			"renderButton",
			"renderError",
			"stepNumber",
			"totalNumSteps",
		]);

		return (
			<StepWrapper {...wrapperProps} handleSubmit={this.handleSubmit}>
				<div className={styles.container}>
					<Input
						className={styles.input}
						inputType={"password"}
						ref={r => (this.passwordInput = r)}
						onUpdate={val => this.updateField("password", val)}
						onEnter={this.handlePasswordEnter}
						initialValue={this.state.password}
						placeholder={"Enter Password"}
						tabIndex={0}
						maxLength={50}
					/>
				</div>
				<div className={styles.container}>
					<Input
						className={styles.input}
						inputType={"password"}
						ref={r => (this.repeatPasswordInput = r)}
						onUpdate={val => this.updateField("repeatPassword", val)}
						onEnter={this.handleRepeatPasswordEnter}
						initialValue={this.state.repeatPassword}
						placeholder={"Enter Password Again"}
						tabIndex={0}
						maxLength={50}
					/>
				</div>
			</StepWrapper>
		);
	},
});
